const CURRENT_YEAR = new Date().getFullYear();

const CartFooter: React.FC = () => {
  return (
    <footer
      data-testid="cart-footer"
      aria-label="Footer"
      className="relative bottom-0 left-0 right-0 w-full p-3 bg-blue text-white"
    >
      <p className="md:mx-auto w-full text-xs items-start md:max-w-[1070px]">
        © {CURRENT_YEAR} ShirtSpace All Rights Reserved.
      </p>
    </footer>
  );
};

export default CartFooter;
